import { SvgIconProps } from '@/types/helpers'

export function Wave({
  type,
  backgroundColor,
  ...props
}: {
  type: 'wave1' | 'wave2' | 'wave3' | 'wave4' | 'wave5'
  backgroundColor: string
  fill: string
} & SvgIconProps) {
  switch (type) {
    case 'wave1': {
      return (
        <div
          className="relative"
          style={{
            background: backgroundColor,
          }}>
          <svg
            viewBox="0 0 1728 152"
            stroke="transparent"
            strokeWidth="0px"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
              d="M1728 152H0V0C0 0 272.7 146.271 857.7 146.271C1442.7 146.271 1728 0 1728 0V152Z"
              fill={props.fill || '#FDCC53'}
            />
          </svg>
          <div
            className="absolute left-0 top-0 -mt-1 h-2 w-full"
            style={{
              background: backgroundColor,
            }}
          />

          <div
            className="absolute left-0 top-full -mt-1 h-2 w-full"
            style={{
              background: props.fill,
            }}
          />
        </div>
      )
    }
    case 'wave2': {
      return (
        <div
          className="relative 2xl:-mt-7"
          style={{
            background: backgroundColor,
          }}>
          <svg
            viewBox="0 0 1728 68"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
              d="M0 0H1728V43.1084C1728 43.1084 1424.7 -36.5232 870.3 34.1074C315.9 104.738 0 43.1084 0 43.1084V0Z"
              fill="currentFill"
            />
          </svg>
          <div
            className="absolute left-0 top-0 -mt-1 h-2 w-full"
            style={{
              background: props.fill,
            }}
          />

          <div
            className="absolute left-0 top-full -mt-1 h-2 w-full"
            style={{
              background: backgroundColor,
            }}
          />
        </div>
      )
    }
    case 'wave3': {
      return (
        <div
          className="relative"
          style={{
            background: backgroundColor,
          }}>
          <svg
            viewBox="0 0 1728 70"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
              d="M0 70H1728V25.1282C1728 25.1282 1424.7 105.449 870.3 34.2012C315.9 -37.0462 0 25.1282 0 25.1282V70Z"
              fill="currentFill"
            />
          </svg>
          <div
            className="absolute left-0 top-0 -mt-1 h-2 w-full"
            style={{
              background: backgroundColor,
            }}
          />

          <div
            className="absolute left-0 top-full -mt-1 h-2 w-full"
            style={{
              background: props.fill,
            }}
          />
        </div>
      )
    }
    case 'wave4': {
      return (
        <div
          className="relative"
          style={{
            background: backgroundColor,
          }}>
          <svg
            viewBox="0 0 1728 68"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
              d="M0 68H1728V24.7573C1728 24.7573 1424.7 103.924 870.3 33.7047C315.9 -36.5142 0 24.7573 0 24.7573V68Z"
              fill={'currentFill'}
            />
          </svg>
          <div
            className="absolute left-0 top-0 -mt-1 h-2 w-full"
            style={{
              background: backgroundColor,
            }}
          />

          <div
            className="absolute left-0 top-full -mt-1 h-2 w-full"
            style={{
              background: props.fill,
            }}
          />
        </div>
      )
    }
    case 'wave5': {
      return (
        <div
          className="relative"
          style={{
            background: backgroundColor,
          }}>
          <svg
            viewBox="0 0 1440 90"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <g clipPath="url(#clip0_7983_82527)">
              <path
                d="M1440 90H0V0C0 0 227.25 86.6077 714.75 86.6077C1202.25 86.6077 1440 0 1440 0V90Z"
                fill="currentFill"
              />
            </g>
            <defs>
              <clipPath id="clip0_7983_82527">
                <rect width="1440" height="90" fill="currentFill" />
              </clipPath>
            </defs>
          </svg>
          <div
            className="absolute left-0 top-0 -mt-1 h-2 w-full"
            style={{
              background: backgroundColor,
            }}
          />

          <div
            className="absolute left-0 top-full -mt-1 h-2 w-full"
            style={{
              background: props.fill,
            }}
          />
        </div>
      )
    }
    default: {
      return null
    }
  }
}
